export const SOSP_ID = 'SOSP_CONTAINER_CUSTOM_ID';
export const PW_HORIZONTAL_WIDTH = 980;
export const PW_VERTICAL_WIDTH = 250;
